/**
 * Formularzustand und Rumpf für „Zähler getauscht" (Spec 46b, Fachregel 6).
 * Reine Abbildung der Felder auf `MeterReplacementCreate`; geprüft wird am
 * Server (Datum, Endstand gegen den letzten Stand, Nummer).
 *
 * Endstand und Anfangsstand sind Ziffernfelder (`reading-draft.ts`): `typed`
 * ist die Folge der getippten Ziffern. Der Anfangsstand beginnt mit einer
 * getippten Null — meist ist ein neuer Zähler bei 0.
 */

import type { MeterReplacementCreate } from '@/features/energy/api'
import { valueOf } from '@/features/energy/reading-draft'

export interface ReplaceFormValues {
  readonly replacedOn: string
  readonly endTyped: string
  readonly newSerial: string
  readonly startTyped: string
}

export function emptyReplaceForm(today: string): ReplaceFormValues {
  return { replacedOn: today, endTyped: '', newSerial: '', startTyped: '0' }
}

/** Endstand und Anfangsstand mit Wert, Nummer nicht leer, Datum gesetzt. */
export function canSaveReplace(form: ReplaceFormValues): boolean {
  return form.endTyped !== '' && form.startTyped !== '' && form.newSerial.trim() !== '' && form.replacedOn !== ''
}

export function toReplacementCreate(form: ReplaceFormValues): MeterReplacementCreate {
  return {
    replaced_on: form.replacedOn,
    end_value: valueOf(form.endTyped) ?? 0,
    new_serial: form.newSerial,
    start_value: valueOf(form.startTyped) ?? 0,
  }
}
